export default __webpack_public_path__ + "static/media/balance-wellness-adjust.5b4fee98.md";